export type Archetype =
  | "classic"
  | "ham"
  | "spicy"
  | "green"
  | "honey"
  | "garlic"
  | "pickle"
  | "butter"
  | "eggstra";

export interface AnswerOption {
  text: string;
  archetype: Archetype;
}

export interface Question {
  id: string;
  question: string;
  options: AnswerOption[];
}

export const quizData: Question[] = [
  {
    id: "q1",
    question: "What’s your ideal Sunday?",
    options: [
      { text: "🛋️ Couch, snacks, no plans", archetype: "butter" },
      { text: "🧘 Morning pilates and market run", archetype: "green" },
      { text: "🥾 Spontaneous hike or adventure", archetype: "pickle" },
      { text: "☕️ Brunch and gossip", archetype: "ham" },
      { text: "📖 Journaling or reading in bed", archetype: "honey" },
    ],
  },
  {
    id: "q2",
    question: "How do you usually make decisions?",
    options: [
      { text: "✅ Logically and methodically", archetype: "eggstra" },
      { text: "💡 I go with my gut", archetype: "spicy" },
      { text: "😌 Whatever feels most chill", archetype: "classic" },
      { text: "🫶 I think about everyone’s feelings", archetype: "honey" },
      { text: "🎲 Flip a coin and roll with it", archetype: "garlic" },
    ],
  },
  {
    id: "q3",
    question: "What do you bring to the friend group?",
    options: [
      { text: "🧠 Structure and plans", archetype: "eggstra" },
      { text: "🎉 Chaos and fun", archetype: "garlic" },
      { text: "🤗 Emotional support", archetype: "honey" },
      { text: "🧘 Calm, balanced energy", archetype: "green" },
      { text: "🧀 The snacks, obviously", archetype: "classic" },
    ],
  },
  {
    id: "q4",
    question: "You’re feeling off. What helps most?",
    options: [
      { text: "💬 Venting to someone", archetype: "ham" },
      { text: "🥗 Nourishing yourself", archetype: "green" },
      { text: "🧸 Alone time with a comfort TV show", archetype: "butter" },
      { text: "🔥 Doing something bold or new", archetype: "spicy" },
      { text: "🎮 Games, memes, total distraction", archetype: "pickle" },
    ],
  },
  {
    id: "q5",
    question: "Pick a food vibe:",
    options: [
      { text: "🥪 Simple and nostalgic", archetype: "classic" },
      { text: "🥗 Fresh and intentional", archetype: "green" },
      { text: "🍜 Something spicy or unexpected", archetype: "pickle" },
      { text: "🍩 Sweet and soft", archetype: "honey" },
      { text: "🍖 Salty and indulgent", archetype: "ham" },
    ],
  },
  {
    id: "q6",
    question: "What’s your communication style?",
    options: [
      { text: "💌 Honest and gentle", archetype: "honey" },
      { text: "📣 Loud and funny", archetype: "ham" },
      { text: "📊 Efficient and clear", archetype: "eggstra" },
      { text: "🌀 Spirals, tangents, chaos", archetype: "garlic" },
      { text: "😎 Laid-back and low-pressure", archetype: "classic" },
    ],
  },
  {
    id: "q7",
    question: "What’s your health tracking style?",
    options: [
      { text: "📈 Daily check-ins, colour-coded", archetype: "eggstra" },
      { text: "🧠 I track when I feel like I need to", archetype: "green" },
      { text: "❓I forget I even started", archetype: "pickle" },
      { text: "🛏️ I just rest and hope for the best", archetype: "butter" },
      { text: "💬 I track vibes more than data", archetype: "spicy" },
    ],
  },
  {
    id: "q8",
    question: "What gives you the ick?",
    options: [
      { text: "😴 People with zero ambition", archetype: "eggstra" },
      { text: "🧊 Emotional unavailability", archetype: "honey" },
      { text: "🙅‍♀️ Too much structure or rules", archetype: "garlic" },
      { text: "💅 People who don’t let loose", archetype: "spicy" },
      { text: "🥱 People who always cancel plans", archetype: "butter" },
    ],
  },
  {
    id: "q9",
    question: "What's your social battery like?",
    options: [
      { text: "🔋 I'm energised by people!", archetype: "ham" },
      { text: "⚖️ I need a mix of social + alone time", archetype: "green" },
      { text: "🪫 Small talk drains me fast", archetype: "honey" },
      { text: "🔌 I plug in when I feel like it", archetype: "pickle" },
      { text: "😌 I’m chill either way", archetype: "classic" },
    ],
  },
  {
    id: "q10",
    question: "If you were a side dish, you'd be...",
    options: [
      { text: "🧄 Garlic bread", archetype: "garlic" },
      { text: "🥗 Kale salad", archetype: "green" },
      { text: "🧀 Mac & cheese", archetype: "classic" },
      { text: "🥚 Boiled eggs", archetype: "eggstra" },
      { text: "🥒 Pickles", archetype: "pickle" },
    ],
  },
];
